import React from 'react'
import { Drawer, Form, Select, Button, Row, Icon, notification } from 'antd'
import { getMarketingUserByUniversityFxn } from '../users/actions/user'
import { updateMarketingUserForAllAgentsFxn } from './actions'

const FormItem = Form.Item
const { Option } = Select

class UpdateMarketingUserDrawer extends React.Component {
  state = {
    selectedUser: null
  }

  componentDidMount() {
    this.loadMarketingUser()
  }

  handleUserChange = (userId) => {
    const user = this.state.marketingUserList.find((u) => u._id === userId)

    this.setState({ selectedUser: user }, () => {
      if (user) {
        this.props.form.setFieldsValue({
          name: user.name,
          email: user.email
        })
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { form, dispatch, countryId, agentId } = this.props
    form.validateFields(async (err, values) => {
      if (!err) {
        if (!countryId) {
          notification.error({ message: 'Country not found' })
          return
        }
        if (!agentId) {
          notification.error({ message: 'Agent not found' })
          return
        }
        if (!values.marketingUserId) {
          notification.error({ message: 'Please choose marketing user' })
          return
        }
        values.countryId = countryId
        values.agentIdsArr = [agentId]

        let resp = await dispatch(updateMarketingUserForAllAgentsFxn(values))
        if (resp && resp.success) {
          this.props.onClose()
        }
        console.log('Form Values:', values)
      }
    })
  }

  /*loadUserList = async () => {
    const { dispatch } = this.props
    let data = await dispatch(getMarketingTeamFxn({ marketingFor: 'unizportal' }))
    if (data.users && data.users.length) {
      this.setState({ marketingUserList: data.users })
    }
  }*/

  loadMarketingUser = async () => {
    let obj = {
      countryId: this.props.countryId,
      university: 'Public'
    }
    let { data } = await getMarketingUserByUniversityFxn(obj)
    this.setState({ marketingUserList: data })
  }


  render() {
    const { visible, onClose, form } = this.props
    const { getFieldDecorator } = form

    return (
      <Drawer
        visible={visible}
        width='30%'
        placement='right'
        onClose={onClose}
        title='Update Marketing User'>
        <div className={'unizportal'}>
          <div className={'card'}>
            <Row style={{ marginBottom: 20, fontSize: 16, fontWeight: 500, color: '#1890ff' }}>
              <Icon type='user' style={{ marginRight: 10 }} />
              Agent: {this.props.agentName} ({this.props.companyName})
            </Row>

            <Form onSubmit={this.handleSubmit} layout='vertical'>
              <FormItem label='Select User'>
                {getFieldDecorator('marketingUserId', {
                  rules: [{ required: true, message: 'Please select a user' }]
                })(
                  <Select
                    placeholder='Select a user'
                    onChange={(e) => {
                      this.setState({
                        marketingUserId: e
                      })
                    }}
                    showSearch
                  >
                    {this.state.marketingUserList && this.state.marketingUserList.length && this.state.marketingUserList.map((user) => (
                      <Option key={user._id} value={user._id}>
                        {user.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>

              <FormItem>
                <Button type='primary' htmlType='submit'>
                  Update User
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </Drawer>
    )
  }
}

export default Form.create()(UpdateMarketingUserDrawer)
